import React from 'react';

import { Container, SliderComponent, StyledThumb, StyledTrack } from './styles';

export default function Slider({
  markin = null,
  markout = null,
  value = 0,
  max,
  color = 'primary',
  ...props
}) {
  const Thumb = (props, state) => (
    <StyledThumb {...props} color={color} o>
      {state.valueNow}
    </StyledThumb>
  );
  const Track = (props, state) => (
    <StyledTrack
      {...props}
      index={state.index}
      color={color}
      single={markin === null}
    />
  );
  // let buttonPressTimer = 0
  // function handleButtonPress(e) {
  //   buttonPressTimer = setTimeout(myFuction, 200)
  // }

  // function myFuction() {
  //   alert('AQUI')
  // }

  // function handleButtonRelease(e) {
  //   clearTimeout(buttonPressTimer)
  // }

  // };

  return (
    // <Container onKeyDown={handleButtonPress} onKeyUp={handleButtonRelease}>
    <Container>
      <SliderComponent
        defaultValue={markin === null ? value : [markin, markout]}
        renderTrack={Track}
        renderThumb={Thumb}
        max={max}
        value={markin === null ? value : [markin, markout]}
        disabled={markin !== null}
        {...props}
      />
    </Container>
  );
}
